import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { formatVND } from "../helpers/common";
import { BacLuong, CauHinhPhuCapResponse, ChiTietThuNhap, ChucDanhChuyenMon, ChucVu, ChucVuDang, ChucVuDoan, ChucVuResponse, ChuyenNganhDaoTao, HeSoLuong, HeSoLuongResponse, NhomLyDoNghiViec, NhomNhanSu, QuyetDinh, ThongBaoLoginResponse, ThongKeTrangChuResponse, ThuNhapCaNhanChart, TrinhDoHVResponse } from "../models/danhmuc/DanhMuc";
import { LoaiHopDong, PhuCap } from "../models/hopdong/HopDong";
import { NhanVienResponse } from "../models/nhanvien/NhanVien";
import { DataSelectBox } from "../models/selectbox";
import intance from "../utils/axios";

export const convertDataSelectBox = (data: any) => {
    let rs: Array<DataSelectBox> = [];
    if (data) {
        rs = data.map((_item: any) => {
            return {
                value: _item.id,
                label: _item.ten || _item.hoTen
            }
        });
    }
    return rs;
}

export const layDsNhomNhanSu= async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.NhomNhanSu)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsChucDanhChuyenMon = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.ChucDanhChuyenMon)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsTrinhDoLLCT = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.TrinhDoLLCT)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsBacLuong = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.BacLuong)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsLoaiNghiPhep = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.LoaiNghiPhep)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsTrinhDoVanHoa= async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.TrinhDoVanHoa)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsChuyenNganhDaoTao= async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.ChuyenNganhDaoTao)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsHinhThucDaoTao= async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.HinhThucDaoTao)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsXepLoaiTotNghiep= async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.XepLoaiTotNghiep)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsHocHam= async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.HocHam)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsDanToc = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.DanToc)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsQuocTich = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.QuocTich)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsTonGiao= async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.TonGiao)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsChucVuDang = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.ChucVuDang)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDanhMucChucVuDang = async () => {
    var data: Array<ChucVuDang> = [];
    await intance.get(`${ApiPaths.danhMuc.ChucVuDang}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuChucVuDang = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuChucVuDang, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaChucVuDang = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaChucVuDang + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};
export const layDanhMucNhomLyDoNghiViec = async () => {
    var data: Array<NhomLyDoNghiViec> = [];
    await intance.get(`${ApiPaths.danhMuc.nhomLyDoNghiViec}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuNhomLyDoNghiViec = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuNhomLyDoNghiViec, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaNhomLyDoNghiViec = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaNhomLyDoNghiViec + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDsChucVuDoan = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.ChucVuDoan)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsTinhThanh = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMucDiaPhuong.layDsTinhThanh)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsPhuongXaTheoIdTinhThanh = async (id: number) => {
    var data: Array<DataSelectBox> = [];
    await intance.get(`${ApiPaths.danhMucDiaPhuong.layDSPhuongXaTheoIdTinhThanh}?id=${id}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDanhMucKetQuaDanhGia = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(`${ApiPaths.danhMuc.ketQuaDanhGia}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDanhMucChucVuDoan = async () => {
    var data: Array<ChucVuDoan> = [];
    await intance.get(`${ApiPaths.danhMuc.ChucVuDoan}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuChucVuDoan = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuChucVuDoan, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaChucVuDoan = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaChucVuDoan + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDanhMucChucVu = async () => {
    var data: Array<ChucVu> = [];
    await intance.get(`${ApiPaths.danhMuc.ChucVu}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDanhMucChucVuResponse = async () => {
    var data: Array<ChucVuResponse> = [];
    await intance.get(`${ApiPaths.danhMuc.ChucVuResponse}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuChucVu = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuChucVu, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaChucVu = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaChucVu + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};


export const layDanhMucHeSoLuongResponse = async () => {
    var data: Array<HeSoLuongResponse> = [];
    await intance.get(`${ApiPaths.danhMuc.HeSoLuongResponse}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuHeSoLuong = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuHeSoLuong, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaHeSoLuong = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaHeSoLuong + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDanhMucNhomNhanSu = async () => {
    var data: Array<NhomNhanSu> = [];
    await intance.get(`${ApiPaths.danhMuc.NhomNhanSu}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};


export const luuNhomNhanSu = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuNhomNhanSu, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaNhomNhanSu = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaNhomNhanSu + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDanhMucBacLuong = async () => {
    var data: Array<BacLuong> = [];
    await intance.get(`${ApiPaths.danhMuc.BacLuong}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};


export const luuBacLuong = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuBacLuong, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaBacLuong = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaBacLuong + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDanhMucHeSoLuong = async (id: number) => {
    var data: Array<HeSoLuong> = [];
    await intance.get(`${ApiPaths.danhMuc.heSoLuong}?id=${id}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const convertDataSelectBoxHeSoLuong = (data: any) => {
    let rs: Array<DataSelectBox> = [];
    if (data) {
        rs = data.map((_item: any) => {
            return {
                value: _item.id,
                label: _item.ten + ";  Hệ số: " + _item.heSo + ";  Mức lương: " + formatVND(_item.mucLuong)
            }
        });
    }
    return rs;
}

export const layDanhMucPhuCap = async () => {
    var data: Array<PhuCap> = [];
    await intance.get(`${ApiPaths.danhMuc.phuCap}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDanhMucLoaiHopDong = async () => {
    var data: Array<LoaiHopDong> = [];
    await intance.get(`${ApiPaths.danhMuc.loaiHopDong}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuLoaiHopDong = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuLoaiHopDong, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaLoaiHopDong = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaLoaiHopDong + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDanhMucChuyenNganhDaoTao = async () => {
    var data: Array<ChuyenNganhDaoTao> = [];
    await intance.get(`${ApiPaths.danhMuc.ChuyenNganhDaoTao}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuChuyenNganhDaoTao = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuChuyenNganhDaoTao, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaChuyenNganhDaoTao = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaChuyenNganhDaoTao + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDanhMucChucDanhChuyenMon = async () => {
    var data: Array<ChucDanhChuyenMon> = [];
    await intance.get(`${ApiPaths.danhMuc.ChucDanhChuyenMon}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuChucDanhChuyenMon = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuChucDanhChuyenMon, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaChucDanhChuyenMon = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaChucDanhChuyenMon + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDanhMucNhanVien = async () => {
    var data: Array<NhanVienResponse> = [];
    await intance.get(`${ApiPaths.danhMuc.nhanVien}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDSNhanVienGiaoViec = async () => {
    var data: Array<NhanVienResponse> = [];
    await intance.get(`${ApiPaths.nhanVien.layDSNhanVienGiaoViec}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const thongKeChungTrangChu = async () => {
    var data: ThongKeTrangChuResponse = new ThongKeTrangChuResponse;
    await intance.get(`${ApiPaths.danhMuc.thongKeTrangChu}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const duLieuThuNhapCaNhan = async (year: number) => {
    var data: Array<ThuNhapCaNhanChart> = [];
    await intance.get(`${ApiPaths.danhMuc.duLieuThuNhapCaNhan}?year=${year}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const chiTietThuNhapCaNhan = async (month: number, year: number) => {
    var data: ChiTietThuNhap = new ChiTietThuNhap;
    await intance.get(`${ApiPaths.danhMuc.chiTietThuNhapCaNhan}?month=${month}&year=${year}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDanhSachLoaiNgayNghi = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.loaiNgayNghi)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDanhMucQuanHeNguoiPhuThuoc = async () => {
    var data: Array<any> = [];
    await intance.get(`${ApiPaths.danhMuc.quanHePhuThuoc}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layCauHinhPhuCap = async () => {
    var data: Array<CauHinhPhuCapResponse> = [];
    await intance.get(`${ApiPaths.danhMuc.layCauHinhPhuCap}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const xoaCauHinhPhuCap = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaCauHinhPhuCap + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const luuCauHinhPhuCap = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuCauHinhPhuCap, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDanhSachThongBaoLogin = async () => {
    var data: Array<ThongBaoLoginResponse> = [];
    await intance.get(`${ApiPaths.danhMuc.layDanhSachThongBaoLogin}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuThongBaoLogin = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuThongBaoLogin, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaThongBaoLogin = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaThongBaoLogin + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDanhMucQuyetDinh = async () => {
    var data: Array<QuyetDinh> = [];
    await intance.get(`${ApiPaths.danhMuc.QuyetDinh}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const luuDmQuyetDinh = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuDmQuyetDinh, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaDmQuyetDinh = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaDmQuyetDinh + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDsLoaiQuyetDinh = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.QuyetDinh)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const layDsNhomLyDoNghiViec = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.nhomLyDoNghiViec)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const LayDSHocHam = async () => {
    var data: Array<TrinhDoHVResponse> = [];
    await intance.get(`${ApiPaths.danhMuc.layDSHocHam}`)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};
export const luuHocHam = async (data: any) => {
    await intance.post(ApiPaths.danhMuc.luuHocHam, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};
export const xoaHocHam = async (id: number) => {
    await intance.post(ApiPaths.danhMuc.xoaHocHam + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layDsLoaiTaiSan = async () => {
    var data: Array<DataSelectBox> = [];
    await intance.get(ApiPaths.danhMuc.loaiTaiSan)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = convertDataSelectBox(res.data.duLieu);
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}